import React from "react";

import { useIntl } from "react-intl";

import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";
import PinLegend from "@mapmycustomers/shared/types/map/PinLegend";

import { getMarkerShapeDisplayName } from "@app/util/ui";

import ShapeBadge from "./ShapeBadge";
import ShapeKey from "./ShapeKey";

interface Props {
  legend: PinLegend;
}

const SimpleShapeKey: React.FC<Props> = ({ legend }) => {
  const intl = useIntl();

  const markerShape =
    legend.thematic?.shapes?.length === 1
      ? (legend.thematic.shapes[0].shape as MarkerShape)
      : undefined;

  return (
    <ShapeKey>
      {markerShape && (
        <ShapeBadge label={getMarkerShapeDisplayName(intl, markerShape)} shape={markerShape} />
      )}
    </ShapeKey>
  );
};

export default SimpleShapeKey;
